import { TouchableOpacity } from "react-native";
import React from "react";

import Text from "@components/CustomText";
import color from "@constants/color";

const Button = ({
  title = "",
  btnColor = "",
  backgroundColor = "",
  onPress,
  children,
}) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={{
        padding: 10,
        borderWidth: 1,
        borderColor: btnColor || color.blank_grey,
        borderRadius: 8,
        flex: 1,
        alignItems: "center",
        marginHorizontal: 6,
        justifyContent: "center",
        flexDirection: "row",
        backgroundColor: backgroundColor || color.white,
      }}
    >
      <Text style={{ color: btnColor }} newfont variant="body_text_4">
        {title}
      </Text>
      {children}
    </TouchableOpacity>
  );
};

export default Button;
